// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"pv_a bhe_sl bhe_uy","ForumSearch__img":"pv_b","ForumSearch__searchAdsAndShoppingAds":"pv_c","ForumSearch__results--empty":"pv_e"};